export default {
  // Cross-chain detail dialog
  dialog: {
    title: 'View Details',
    sourceSection: {
      hashLabel: 'Source Transaction Hash',
      timeLabel: 'Initiated Time:'
    },
    targetSection: {
      hashLabel: 'Target Transaction Hash',
      timeLabel: 'Received Time:'
    },
    sender: 'Sender',
    receiver: 'Receiver',
    flowText: 'Cross-Chain Exchange',
    copySuccess: 'Copied Successfully!'
  },
  
  // Cross-chain list
  list: {
    sort: {
      sendAmount: 'Send Amount',
      sendTime: 'Send Time',
      receiveAmount: 'Receive Amount',
      receiveTime: 'Receive Time',
      desc: 'Descending',
      asc: 'Ascending'
    },
    hash: {
      source: 'Source Hash:',
      target: 'Target Hash:'
    },
    grid: {
      sender: 'Sender',
      receiver: 'Receiver',
      sendAmount: 'Send Amount',
      sendTime: 'Send Time',
      receiveAmount: 'Receive Amount',
      receiveTime: 'Receive Time'
    },
    buttons: {
      trace: 'Cross-Chain Tracking',
      detail: 'Details'
    },
    messages: {
      traceSuccess: 'Cross-chain tracking successful!',
      traceFailed: 'Cross-chain tracking failed, please try again later',
      chainNotSupportedWithName: 'Current cross-chain tracking to {chainName} chain is not supported for canvas analysis. Would you like to view the data in the blockchain explorer?',
      chainNotSupportedGeneric: 'The current cross-chain tracking result chain is not supported for canvas analysis. Would you like to view the data in the blockchain explorer?',
      tip: 'Tip',
      cancel: 'Cancel',
      viewInBrowser: 'View in Browser'
    },
    download: {
      filename: 'Cross-Chain Transaction Details.xlsx'
    }
  }
}